import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_BASE = 'https://oauth.remote-assistant.ai';

function getOrCreateSessionId() {
  let id = sessionStorage.getItem('ra_session_id');
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem('ra_session_id', id);
  }
  return id;
}

function saveUtmParams(params) {
  if (sessionStorage.getItem('ra_utm_source')) return; // only capture first-touch
  const utm_source = params.get('utm_source');
  if (!utm_source) return;
  sessionStorage.setItem('ra_utm_source', utm_source);
  sessionStorage.setItem('ra_utm_medium', params.get('utm_medium') || '');
  sessionStorage.setItem('ra_utm_campaign', params.get('utm_campaign') || '');
}

function getStoredUtm() {
  return {
    utm_source: sessionStorage.getItem('ra_utm_source') || '',
    utm_medium: sessionStorage.getItem('ra_utm_medium') || '',
    utm_campaign: sessionStorage.getItem('ra_utm_campaign') || '',
  };
}

export function trackConversion(event, path) {
  fetch(`${API_BASE}/analytics/conversion`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      session_id: getOrCreateSessionId(),
      event,
      path: path || window.location.pathname,
      timestamp: new Date().toISOString(),
      ...getStoredUtm(),
    }),
    keepalive: true,
  }).catch(() => {});
}

function collectVitals(onVitals) {
  const vitals = {};
  const report = () => { if (Object.keys(vitals).length > 0) onVitals({ ...vitals }); };

  try {
    new PerformanceObserver(list => {
      const e = list.getEntries().at(-1);
      vitals.lcp = parseFloat((e.startTime / 1000).toFixed(3));
      report();
    }).observe({ type: 'largest-contentful-paint', buffered: true });

    new PerformanceObserver(list => {
      let cls = 0;
      list.getEntries().forEach(e => { if (!e.hadRecentInput) cls += e.value; });
      vitals.cls = parseFloat(cls.toFixed(4));
      report();
    }).observe({ type: 'layout-shift', buffered: true });

    new PerformanceObserver(list => {
      const e = list.getEntries().at(-1);
      vitals.inp = Math.round(e.processingStart - e.startTime);
      report();
    }).observe({ type: 'event', buffered: true, durationThreshold: 40 });
  } catch (_) {}
}

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    saveUtmParams(params);
    const payload = {
      session_id: getOrCreateSessionId(),
      path: location.pathname,
      referrer: document.referrer,
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      timestamp: new Date().toISOString(),
    };

    fetch(`${API_BASE}/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});

    collectVitals(vitals => {
      fetch(`${API_BASE}/analytics/pageview`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, vitals }),
        keepalive: true,
      }).catch(() => {});
    });
  }, [location.pathname]);
}
